import styled from "styled-components";

export default styled.div`
  padding: 3vw 6vw 3vw 6vw;

  .title {
    margin-bottom: 5px !important;
  }
  .content {
    margin-bottom: 5px !important;
  }
  .info {
    font-size: 12px;
    color: #797979;
    .icon {
      font-size: 11px;
      height: auto;
      width: auto;
    }
    span {
      cursor: pointer;
    }
  }
  .modalImg {
    margin-top: -5px;
  }
`;
